import pb from "../../../lib/pocketbase";
import Container from "../../../components/Container";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { IInboxRecord } from "../../../lib/types";
import InboxListItem from "../../../components/studio/inbox/InboxListItem";
import Button from "../../../components/form/button";

export default function ArchivedInbox() {
    const [messages, setMessages] = useState<IInboxRecord[]>();
    const navigate = useNavigate();

    async function load() {
        const inbox: IInboxRecord[] = await pb.collection("inbox").getFullList({
            filter: "archived = true",
            sort: "read, -created"
        });
        setMessages(inbox);
    }
    useEffect(() => {
        if (!pb.authStore.isValid) {
            navigate("/studio/login");
        }
        if (pb.authStore?.model?.role < 1) {
            navigate(-1);
        }
        load();
    }, []);
    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Inbox Archive</title>
            </Helmet>
            <Container className="mb-8 mt-4 md:mt-8 lg:mt-16">
                <div className="flex items-center justify-between">
                    <h2 className="text-3xl font-bold">Inbox Archive</h2>
                    <Link to="/studio/inbox">
                        <Button size={"small"}>back</Button>
                    </Link>
                </div>
                <div className="mt-8 flex flex-col gap-4">
                    {messages?.map((message) => (
                        <InboxListItem archived message={message} />
                    ))}
                </div>
            </Container>
        </>
    );
}
